<template>
  <div>
    <div class="ui form">
      <div class="fields">
        <div class="eleven wide field">
          <label>{{ $t("components.usersGroupForm.Nombre") }}</label>
          <div class="ui input">
            <input type="text" disabled v-model="currentUserMantainer.name">
          </div>
        </div>
        <div class="five wide field">
          <label>{{ $t("components.usersGroupForm.Login") }}</label>
          <div class="ui input">
            <input type="text" disabled v-model="currentUserMantainer.login">
          </div>
        </div>
      </div>
      <div class="fields">
        <div class="ui styled accordion" style="width:100%">
          <div class="title active" style="background: #8bb040;color: white;">
            <i class="dropdown icon"></i>
            {{ $t("components.usersGroupForm.Usuarios_asignados") }}
            <span v-if="currentPlainUsers.length">( {{ currentPlainUsers.length }} )</span>
          </div>
          <div class="content active">
            <div v-for="currentPlainUser in currentPlainUsers" v-bind:key="currentPlainUser._id">
              <div class>
                <div class="active content" style="padding-top:0px; padding-bottom:0px">
                  <div class="fields">
                    <div class="fourteen wide field" >
                      <select class="ui dropdown fluid" v-bind:id="'selectedPlainUser' + currentPlainUser._id">
                        <option value="0">{{ $t("components.usersGroupForm.Seleccione_un_usuario") }}</option>
                        <option v-for="userPlainUser in allUsersPlainUser" v-bind:key="userPlainUser._id" :value="userPlainUser._id">{{ userPlainUser.name + ' (' + userPlainUser.login + ')' }}</option>
                      </select>
                    </div>
                    <div class="two wide field" style="padding-top:5px;">
                      <button class="circular basic ui icon button red mini floated right" @click="removePlainUser(currentPlainUser._id)">
                        <i class="remove icon"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button class="circular ui icon button olive mini" @click="addPlainUser()">
              <i class="icon add"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <h2 class="ui dividing header"></h2>
    <button class="ui olive labeled icon button" style="float:right" @click="save()">
      <i class="icon add"></i>{{ $t('components.common.Guardar') }}
    </button>
    <router-link class="item" to="/usersGroups">
      <button class="ui labeled icon button" style="float:right">
        <i class="remove icon"></i> {{ $t('components.common.Volver') }}
      </button>
    </router-link>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../utils/axios-general';
import Vue from 'vue';

export default {
  name: 'UsersGroupForm',
  data: function () {
    return {
      currentUserMantainer: { name: '', login: '' },
      allUsersPlainUser: [],
      currentPlainUsers: [],
    };
  },
  methods: {
    refresh: function () {
      let getUrl = "/usersGroups";

      if (this.$route.params.idUser != null) {
        getUrl += "/" + this.$route.params.idUser;
      }

      axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
      axios.get(getUrl).then(response => {
        if (response) {
          this.allUsersPlainUser = response.data.usersPlainUser;
          this.currentUserMantainer = response.data.userMantainer;

          this.currentUserMantainer.users.forEach((userId) => {
            const userPlainUser = this.allUsersPlainUser.find((u) => u._id === userId);
            if (userPlainUser) {
              this.currentPlainUsers.push(userPlainUser);
            }
          });

          Vue.nextTick(() => {
            this.currentPlainUsers.forEach((u) => {
              $('#selectedPlainUser' + u._id).dropdown('set selected', (u != null) ? u._id : 0);
            });
          });
        }
      }).catch((e, a, b, c) => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.usersGroupForm.Hay_un_error_obtener_datos'),
          text: e
        });
      });
    },
    addPlainUser: function () {
      this.currentPlainUsers.push({ _id: parseInt(Math.random() * 1000000) });

      Vue.nextTick(() => {
        $('.ui.dropdown').dropdown();
      });
    },
    removePlainUser: function (idPlainUser) {
      this.currentPlainUsers = this.currentPlainUsers.filter((u) => u._id !== idPlainUser);
    },
    save: function () {
      // obtenemos la lista de usuarios (descartando los no seleccionados y los repetidos)
      const newUsers = [];
      for (let i = 0; i < this.currentPlainUsers.length; i++) {
        const idUser = (($('#selectedPlainUser' + this.currentPlainUsers[i]._id).val() == null) || ($('#selectedPlainUser' + this.currentPlainUsers[i]._id).val() === 0)) ? null : $('#selectedPlainUser' + this.currentPlainUsers[i]._id).val();
        const selectedUser = this.allUsersPlainUser.find((u) => u._id === idUser);

        if ((selectedUser != null) && (newUsers.find((u) => u._id === selectedUser._id) == null)) {
          newUsers.push(selectedUser._id);
        }
      }
      this.currentPlainUsers = newUsers;

      axios.put('/usersGroups/' + this.currentUserMantainer._id, { users: this.currentPlainUsers }).then(response => {
        this.$swal.fire(
          this.$i18n.t('components.usersGroupForm.Save_Ok_Title'),
          this.$i18n.t('components.usersGroupForm.Save_Ok_Text'),
          'success'
        );

        this.$router.push({ name: 'usersGroups' });
      }).catch(e => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.usersGroupForm.Hay_un_error_actualizar'),
          text: e
        });
      });
    }
  },
  mounted: function () {
    this.refresh();

    setTimeout(() => {
      $('.accordion').accordion({
        exclusive: false,
        selector: {
          trigger: '.title'
        }
      });

      $('.ui.dropdown').dropdown();
    }, 500);
  }
};
</script>
